export const palette = {
  visibility: '#8A82FF',
  visibility_range: [
    {
      color: '#120992',
      max: 100,
      min: 66,
    },
    {
      color: '#6259E8',
      max: 66,
      min: 33,
    },
    {
      color: '#B3AEFF',
      max: 33,
      min: 0,
    },
  ],
  organicRange: [
    {
      color: 'rgba(13, 105, 55, 1)',
      max: 100,
      min: 66,
    },
    {
      color: 'rgba(24, 161, 85, 1)',
      max: 66,
      min: 33,
    },
    {
      color: 'rgba(150, 226, 184, 1)',
      max: 33,
      min: 0,
    },
  ],
  paidRange: [
    {
      color: '#DAA335',
      max: 100,
      min: 66,
    },
    {
      color: '#E3B864;',
      max: 66,
      min: 33,
    },
    {
      color: '#EED4A0',
      max: 33,
      min: 0,
    },
  ],
  blended: {
    ctr: '#5119B7',
    cpc: '#E4D9F8',
  },
  organic: '#18A155',
  savings: '#18A155',
  paid: {
    search: '#FFB700',
    shopping: '#FF8C00',
  },
  traffic: {
    brand: '#637381',
    brandSearches: '#EE7A63',
    brandSearchesMonthly: '#EE7A63',
    uncaptured: '#637381',
  },
  cost: {
    signal: '#EE7A63',
  },
  overlap: '#1877F2',
  revenue: '#0052B4',
  conversions: '#0052B4',
  paidShoppingShare: {
    first: '#FF8C00',
    then: '#FFBA66',
    compet: '#FFE8CC',
  },
  paidSearchShare: {
    first: '#FFB700',
    then: '#FFD466',
    compet: '#FFF1CC',
  },
};
